export default {"src":"/_next/static/media/circle-xmark.552b84a7.svg","height":640,"width":640,"blurWidth":0,"blurHeight":0};